// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__kNWs5","header":"MergedInvoice_header__tzJ56"};